import { createFormAction } from 'redux-form-saga'
export const LOGIN_FORM_KEY = 'LOGIN_FORM_KEY'
export const LoginFormAction = createFormAction(LOGIN_FORM_KEY)

